import useStudenDetailsDocumentParams from '../hooks/useStudentDetailsDocumentParams'
import {
  FrameCornerIcon,
  SparkleIcon,
  StackSampleIcon,
} from '@/app/common/icons/general'
import { Button } from '@/app/common/components/Button'
import { useTranslation } from 'react-i18next'

interface IProps {
  name: string
  onContinueClick: () => void
  onCantFindClick: () => void
}

export const CaptureInstructions = ({
  name,
  onContinueClick,
  onCantFindClick,
}: IProps) => {
  const { t: translate } = useTranslation()
  const { info } = useStudenDetailsDocumentParams()
  const selectedForm = info()

  const isRelationshipDocument = selectedForm?.code === 'relation_to_student'

  return (
    <>
      <div className="text-lg text-center mt-10 px-10">
        {translate('document_capture_instructions').replace(
          ':document_name',
          translate(selectedForm?.longName ?? selectedForm.name)
        )}
      </div>

      <div className="mt-6">
        <div className="flex items-center">
          <div className="w-5 flex justify-center">
            <FrameCornerIcon />
          </div>
          <div className="ml-4 text-sm">
            {translate('position_your_document')}
            {selectedForm.additional_info && (
              <>
                <br />({translate(selectedForm.additional_info)})
              </>
            )}
          </div>
        </div>
      </div>

      <div className="mt-6">
        <div className="flex items-center">
          <div className="w-5 flex justify-center">
            <StackSampleIcon />
          </div>
          <div className="ml-4 text-sm">
            {translate('place_it_flat_surface')}
          </div>
        </div>
      </div>

      <div className="mt-6">
        <div className="flex items-center">
          <div className="w-5 flex justify-center">
            <SparkleIcon />
          </div>
          <div className="ml-4 text-sm">{translate('avoid_glare_shaking')}</div>
        </div>
      </div>

      <div className="mt-6">
        <div className="flex items-center">
          <div className="w-5 flex justify-center">
            <FrameCornerIcon />
          </div>
          <div className="ml-4 text-sm">
            {translate('camera_directly_above')}
          </div>
        </div>
      </div>

      <div className="text-center h-full flex">
        <div className="flex justify-end my-5 w-full flex-col">
          <Button onClick={onContinueClick} className="rounded h-9 mb-5">
            {translate('continue')}
          </Button>
          {!isRelationshipDocument && (
            <Button
              className="text-sm leading-5 font-semibold text-primary bg-transparent hover:bg-transparent cursor-pointer"
              onClick={onCantFindClick}
            >
              {translate('i_dont_have_xyz_document', {document: translate(name)})}
            </Button>
          )}
        </div>
      </div>
    </>
  )
}
